/**
 * a collection of utility methods to validate a limitless user
 */

/**
 *
 * Checks to see if a user object is valid
 *
 * @param {object} user
 */
export const isUserValid = user => {
  if (!user) {
    return false;
  }
  return isNameValid(user.name) && isEmailValid(user.email) && isEmailHashValid(user.customerEmailHash);
};

/**
 * Validates a user's email hash
 *
 * @param {string} emailhash
 */
export const isEmailHashValid = emailhash => {
  return emailhash !== "";
};

/**
 * Validates a user's name
 *
 * @param {string} name
 */
export const isNameValid = name => {
  if (!name) {
    return false;
  }
  const trimmedName = name.trim();
  return trimmedName.length > 1;
};

/**
 * Validates a customer verification code
 *
 * @param {string} email
 */

export const isCustomerCodeValid = code => {
  if (!code) {
    return false;
  }
  if (code.length > 4) {
    return true;
  }
  return false;
};

/**
 * Validates a user's email
 *
 * @param {string} email
 */
export const isEmailValid = email => {
  if (!email) {
    return false;
  }
  if (/\s/.test(email)) {
    // It has any kind of whitespace
    return false;
  }
  if (/[^ -~]+/.test(email)) {
    // It has any kind of control character
    return false;
  }
  if (email.includes("'")) {
    // It has an apostrophe
    return false;
  }

  /* if the last character is not a letter it should be invalid*/

  const lastChar = email.substr(email.length - 1);
  const lettersRegex = /[a-zA-Z]/i;
  if (!lettersRegex.test(lastChar)) {
    return false;
  }
  const firstChar = email.charAt(0);
  const lettersNumbersRegex = /[a-zA-Z0-9-]/i;
  if (!lettersNumbersRegex.test(firstChar)) {
    return false;
  }

  // eslint-disable-next-line
  const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email);
};

// Should url validation and others be inside user validation or should we call it field validation?
// placing in here for now because its the same place as email validation
export const isUrlValid = url => {
  if (!url) {
    return false;
  }
  if (/\s/.test(url)) {
    return false;
  }
  if (subsequenceDots(url)) {
    return false;
  }
  // eslint-disable-next-line
  const regex = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi;
  return regex.test(url);
};
export const isMobileValid = inputNumber => {
  // eslint-disable-next-line
  const mobileNumber = inputNumber.replace(new RegExp(" ", "g"), "");
  if (mobileNumber.length < 1) {
    return true;
  }
  if (mobileNumber.length > 15) {
    return false;
  }
  const regex = /^\+?[1-9]\d{1,14}$/u;
  const checkValidMobile = mobileNumber.match(regex);
  if (checkValidMobile !== null) {
    return true;
  }
  return false;
};
const subsequenceDots = str => {
  let first = -1;
  let i = -1;
  let flag = false;
  while ((i = str.indexOf(".", i + 1)) >= 0) {
    if (first + 1 === i) {
      flag = true;
    } else if (!flag) {
      first = i;
    }
  }
  return flag;
};